import { render, staticRenderFns } from "./CodeDetailView.vue?vue&type=template&id=3169d03f&scoped=true"
import script from "./CodeDetailView.vue?vue&type=script&lang=js"
export * from "./CodeDetailView.vue?vue&type=script&lang=js"
import style0 from "./CodeDetailView.vue?vue&type=style&index=0&id=3169d03f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3169d03f",
  null
  
)

export default component.exports